import styled from 'styled-components';

import { SPACING } from '~/common/layout-propertis/spacing';

export const StructuredTooltipContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: start;
  gap: ${SPACING._12};
  padding: ${SPACING._12};
`;

export const IconWrapper = styled.div`
  height: 20px;
  width: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING._4};
`;

export const CloseWrapper = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
